import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ChevronUp({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'14px'} height={'8px'} viewBox={'0 0 14 8'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-5.000000, -8.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6834175,7.90236893 12.3165825,7.90236893 12.7071068,8.29289322 L18.7071068,14.2928932 C19.0976311,14.6834175 19.0976311,15.3165825 18.7071068,15.7071068 C18.3165825,16.0976311 17.6834175,16.0976311 17.2928932,15.7071068 L12,10.4142136 L6.70710678,15.7071068 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

ChevronUp.propTypes = {
  className: PropTypes.string,
}
